import type { RouteObject } from "react-router-dom";
import AgentAppDetail from "@/pages/agent/AgentAppDetail";
import AgentApps from "@/pages/agent/AgentApps";
import AgentOverview from "@/pages/agent/AgentOverview";
import AgentStats from "@/pages/agent/AgentStats";
import AgentTrace from "@/pages/agent/AgentTrace";
import Agents from "@/pages/agent/Agents";
import CreateAgent from "@/pages/agent/CreateAgent";
import CreateAgentInstance from "@/pages/agent/CreateAgentInstance";
import EditAgent from "@/pages/agent/EditAgent";


export const agentRoutes: RouteObject[] = [
  { path: "/agents", element: <Agents /> },
  { path: "/agent-templates", element: <Agents /> },
  { path: "/agents/create", element: <CreateAgent /> },
  { path: "/agents/:uid/edit", element: <EditAgent /> },
  {
    path: "/agents/:uid/create-instance",
    element: <CreateAgentInstance />,
  },
  { path: "/agents/:id", element: <AgentOverview /> },
  { path: "/agents/:id/apps", element: <AgentApps /> },
  {
    path: "/agents/:id/apps/:appId",
    element: <AgentAppDetail />,
  },
  { path: "/agents/:id/trace", element: <AgentTrace /> },
  { path: "/agents/:id/stats", element: <AgentStats /> },
];
